




































































import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Menu from '@/components/common/Menu.vue';
import { usersService } from '@/services/UsersService';
import Datepicker from 'vuejs-datepicker';
import { format, formatDistance } from 'date-fns';
import { pl, enGB } from 'date-fns/locale';
import * as FileSaver from 'file-saver';
import EventBus from '@/EventBus';
import { en as datepickerEN, pl as datepickerPL } from 'vuejs-datepicker/dist/locale';
// import * as Papa from 'papaparse';

@Component({
  components: {
    Header,
    Menu,
    Datepicker,
  },
})
export default class Users extends Vue {
  workspaceId = 0;
  format = 'yyyy-MM-dd';
  filterDateFrom = '';
  filterDateTo = '';
  logs: any = {};
  paginationData = {
    per_page: 20,
    page: 1,
    size: 0,
    total: 0,
  };
  paginationNumbers: any = [];
  lastPageNumber = 1;
  language = this.$root.$i18n.locale;

  getFilteredLogs(date: any, type: string, pageNr: number) {
    if (!date) {
      return;
    }
    if (type === 'from') {
      this.filterDateFrom = format(new Date(date), 'yyyy-MM-dd');
    } else {
      this.filterDateTo = format(new Date(date), 'yyyy-MM-dd');
    }

    if (!this.filterDateFrom || !this.filterDateTo) {
      return;
    }
    this.getLogsWithDate(pageNr);
  }

  getLogsWithDate(pageNr: number) {
    usersService
      .getLogsFilteredDate(this.workspaceId, pageNr, this.filterDateFrom, this.filterDateTo)
      .then((data: any) => {
        this.logs = data.logs;
        this.paginationData = data.pagination;
        this.getPaginationNumbers();
      });
  }

  formatDate(date: string) {
    return date ? format(new Date(date), 'HH:mm:ss  dd.MM.yyyy') : '';
  }

  descriptiveDateFormat(date: string) {
    return formatDistance(new Date(date), new Date(), {
      addSuffix: true,
      locale: this.language === 'pl' ? pl : enGB,
    });
  }

  getDatepickerLang() {
    return this.$root.$i18n.locale === 'pl' ? datepickerPL : datepickerEN;
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.getAuditLogs(1);
    this.language = localStorage.getItem('locale') || this.$root.$i18n.locale;
    EventBus.$on('update-current-audit-log-page', () => {
      this.setPage(this.lastPageNumber);
    });
  }

  getAuditLogs(page: number) {
    this.lastPageNumber = page;
    return usersService.getAuditLogs(this.workspaceId, page).then((data: any) => {
      this.logs = data.logs;
      this.paginationData = data.pagination;
      this.getPaginationNumbers();
    });
  }

  getReportFileNameDateFormat(date: Date) {
    return date ? format(date, 'yyyyMMdd') : '';
  }

  getCSVfile(dateFrom: string, dateTo: string) {
    return usersService.getCSVfile(this.workspaceId, dateFrom, dateTo).then((data: any) => {
      /*
      const csvdata: any = Papa.parse(data);
      for (const i in csvdata.data) {
        if (csvdata.data[i][7]) {
          csvdata.data[i][8] = this.$t(csvdata.data[i][6], JSON.parse(csvdata.data[i][7]));
        }
      }
      const parsedData = Papa.unparse(csvdata.data);
      */
      const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
      FileSaver.saveAs(
        blob,
        'logs_workspace' +
          this.workspaceId +
          '_' +
          this.getReportFileNameDateFormat(new Date(dateFrom)) +
          '_' +
          this.getReportFileNameDateFormat(new Date(dateTo)) +
          '.csv'
      );
    });
  }

  getPaginationNumbers() {
    const pagesNumber = Math.ceil(this.paginationData.total / this.paginationData.per_page);

    if (pagesNumber > 7) {
      const tempNumbers: any = [];
      let startIndex = 1;
      if (this.paginationData.page > 4) {
        tempNumbers.push({ nr: this.paginationData.page - 3, label: '...' });
        startIndex = this.paginationData.page - 2;
      }
      for (let i = startIndex; i < this.paginationData.page; i += 1) {
        if (i > 0) {
          tempNumbers.push({ nr: i, label: i });
        }
      }
      tempNumbers.push({ nr: this.paginationData.page, label: this.paginationData.page * 1 });
      let addedPages = 0;
      for (let i = this.paginationData.page * 1 + 1; i <= pagesNumber; i += 1) {
        if (addedPages < 3) {
          addedPages += 1;
          tempNumbers.push({ nr: i, label: i });
        } else {
          tempNumbers.push({ nr: i, label: '...' });
          break;
        }
      }
      this.paginationNumbers = tempNumbers;
    } else {
      this.paginationNumbers = new Array(pagesNumber).fill(0).map((e, i) => {
        return { nr: i + 1, label: i + 1 };
      });
    }
  }

  setPage(nr: number) {
    const pagesNumber = Math.ceil(this.paginationData.total / this.paginationData.per_page);
    if (nr >= 0 && nr <= pagesNumber) {
      if (!this.filterDateFrom || !this.filterDateTo) {
        this.getAuditLogs(nr);
      } else {
        this.getLogsWithDate(nr);
      }
    }
  }

  prevPage() {
    this.setPage(this.paginationData.page - 1);
  }

  nextPage() {
    this.setPage(this.paginationData.page + 1);
  }
}
